import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ApiConfig } from './config/api.config';
import { Beneficiary } from '../models/beneficiary.model';
import { Lista } from '../models/lista.model';

@Injectable()
export class CertificateService{

    constructor(
        private http: HttpClient,
        private api: ApiConfig    
    ){}

    postGenerateCertified(contrato : number, afiliado : number, tipoCertificado : number, periodoCertificado : number) : Observable<number> {
        return this.http.post<number>(this.api.url + '/certificates/generatecertified', { contrato, afiliado, tipoCertificado, periodoCertificado });
    }

    getDownloadPdf(idCertificate : number) : Observable<any>{       
        return this.http.get(this.api.url + '/certificates/download/' + idCertificate, { responseType: 'blob'});
    }

    getYears(contract : string) : Observable<Array<Lista>>{
        return this.http.get<Array<Lista>>(this.api.url + '/certificates/years/' + contract + '/1/1900');
    }

    getValidateCertified(contrato : number, afiliado : number, tipoCertificado : number, diasVigencia : number) : Observable<number> {
        return this.http.get<number>(this.api.url + '/certificates/validatecertified/' + tipoCertificado + '/' + afiliado + '/' + contrato + '/' + diasVigencia );
    }

}


// WEBPACK FOOTER //
// /app/src/app/shared/services/certificate.service.ts